import { ToastMessageType } from "../components/toast/ToastContext";

export const DeviceToasts: { [key: string]: ToastMessageType } = {
  deviceCreated: {
    severity: "success",
    summary: "Registrierung erfolgreich",
    detail: "Die Meldeinstanz wurde erfolgreich registriert",
  },
  deviceCreationError: {
    severity: "error",
    summary: "Registrierung fehlgeschlagen",
    detail:
      "Die Registrierung der Meldeinstanz konnte nicht durchgeführt werden",
  },
  deviceDeleted: {
    severity: "success",
    summary: "Meldeinstanz entfernt",
    detail: "Die Meldeinstanz wurde erfolgreich entfernt",
  },
  deviceDeletionError: {
    severity: "error",
    summary: "Erntfernen fehlgeschlagen",
    detail: "Die Meldeinstanz konnte nicht entfernt werden",
  },
  deviceSettingsSaved: {
    severity: "success",
    summary: "Einstellungen gespeichert",
    detail:
      "Die Einstellungen für die Meldeinstanz wurden erfolgreich gespeichert",
  },
  deviceSettingsSaveError: {
    severity: "error",
    summary: "Speichern fehlgeschlagen",
    detail:
      "Die Änderungen an der Meldeinstanz konnten nicht gespeichert werden",
  },
  desktopUserCreationSuccess: {
    severity: "success",
    summary: "Nutzer erstellt",
    detail:
      "Es wurde ein neuer Nutzer erstellt und der Meldeinstanz zugewiesen",
  },
  desktopUserCreationError: {
    severity: "error",
    summary: "Nutzererstellung fehlgeschlagen",
    detail:
      "Es konnte kein Nutzer für die angegebene Email Adresse erstellt werden. Bitte Kontaktieren Sie den Support",
  },
  desktopUserAlreadyExistsError: {
    severity: "error",
    summary: "Nutzeraccount existiert bereits",
    detail:
      "Nutzer konnte nicht angelegt werden, da zur angegebenen Email bereits ein Account existiert",
  },
};
